// PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import Swal from "sweetalert2";

const PrivateRoute = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem("token");

  if (!isAuthenticated) {
    Swal.fire({
      icon: "warning",
      title: "Connexion obligatoire",
      text: "Veuillez vous connecter",
      confirmButtonText: "OK",
      customClass: {
        confirmButton: "swal-btn-ok"
      }
    });
    return <Navigate to="/page accueil" replace />;
  }

  return children;
};

export default PrivateRoute;
